import { render, staticRenderFns } from "./Editansweroption.vue?vue&type=template&id=0fa3f4a4&"
import script from "./Editansweroption.vue?vue&type=script&lang=js&"
export * from "./Editansweroption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports